import { RouteConfig } from 'vue-router';
import Renewalmanager from './components/renewalmanager.component.vue';

export const renewalmanager: RouteConfig = {
  path: 'renewalManager',
  component: Renewalmanager,
};
